<div class="row text-center ma-check-ur-email" [ngClass]="{'m-top':addTopMargin}">
  <div class="col">
    <div class="header-icon margin-bottom mb8">
      <figure>
        <img src="./assets/img/images/email.svg" alt="Email" />
      </figure>
    </div>
    <h1 class="title-copy font-weight-normal">{{ "CHECK_YOUR_EMAIL" | translate }}</h1>
      <ng-container *ngIf="isAcmic; else maText">
        <p class="mb-4">    
          {{ "WE_HAVE_SENT_AN_EMAIL_WITH_LINK" | translate }}
        </p>
      </ng-container>
      <ng-template #maText>
        <div>
          We have sent an email with
        </div>
        <div>
          a link to validate your account to:
        </div>
      </ng-template>          
    <div class="email-title font-medium font-weight-bold mb-4 mt-4 lh24">
      {{ email }}
    </div>
    <p class="mb-0">
      {{ "MAKE_SURE_TO_REVIEW_YOUR_SPAN_FOLDER" | translate }}
    </p>
    <p class="mb-2">
      {{ "DIDNT_RECEIVE_EMAIL" | translate }}
    </p>
    <div class="s-code dm-sans-medium font-weight-500 font-size-16 mb-1 " (click)="resendEmail()">
      {{ "FORGOT_EMAIL_SEND_AGAIN" | translate }}
    </div>
    
    <p class="mt-3 mb-2">
      {{ "OR_CONTACT_OUR_CUSTOMER_SERVICE" | translate }}
    </p>
    <p>
        <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mapfre link blue-link" [ngClass]="{ 'corporate-red font-size-16 font-weight-500 dm-sans-medium': !isAcmic , 'underline': isAcmic}">
            {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
        </a>
      </p>
  </div>
  <div class="row margin-top text-center checkingrowbtm">
    <div class="col">
      <mapfre-button
        (click)="goBack()"
        additionalClasses="link-button small-btn red-link no-margin button-border-red"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [showIconsCustom]="true"
      >
        {{ "BACK" | translate }}
      </mapfre-button>
    </div>
  </div>
</div>
